import { render } from "./SectionPortfolioDetailScreenshot.vue?vue&type=template&id=54f3e1da&scoped=true"
import script from "./SectionPortfolioDetailScreenshot.vue?vue&type=script&lang=js"
export * from "./SectionPortfolioDetailScreenshot.vue?vue&type=script&lang=js"

import "./SectionPortfolioDetailScreenshot.vue?vue&type=style&index=0&id=54f3e1da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f3e1da"]])

export default __exports__